import { Star } from "@mui/icons-material"
import { Box, Rating } from "@mui/material"
import axios from "axios"
import { useState } from "react"
import { useNavigate } from "react-router-dom"

const Review = () => {
    const [rating,setRating] = useState(2.5)
    const [hover, setHover] = useState(-1);
    const [formData,setFormData] = useState({ name: "", phone: "", rating: "", subject: "New Riverside Review:", message: "" })
    const navigate = useNavigate()
    const handleSideNav = () => {
        if (document.querySelector(".main-nav").classList.contains("slidenav")) {
            document.querySelector(".main-nav").classList.remove("slidenav")
        }
    }

    const labels = {
        0.5: 'Very Bad',
        1: 'Bad',
        1.5: 'Very Poor',
        2: 'Poor',
        2.5: 'Ok',
        3: 'Average',
        3.5: 'Good',
        4: 'Very Good',
        4.5: 'Excellent',
        5: 'Perfect',
    };

    function getLabelText(value) {
        return `${value} Star${value !== 1 ? 's' : ''}, ${labels[value]}`;
    }
    

    const handleSubmit = async (e) => {
        e.preventDefault()
        console.log(formData)


        try {
            const response = await axios.post(`https://riverside-api-f5ebf4643370.herokuapp.com/email/review`,formData)
            console.log(response)
            navigate("/cthk")
        } catch (error) {
            console.log(error)
            window.location.reload()   
        }
    }

    return (
        <div onClick={handleSideNav}>

            <div className="breadcrumb">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadcrumb-wrapper">
                                <div className="breadcrumb-inner">
                                    <h1>Feedback</h1>
                                    <span><a href="/">Home<i className="fas fa-angle-right"></i></a>Give Us Feedback</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="contact-area sec-mar">
                <div className="container">
                    <div className="row g-4">
                        {/* <div className="col-md-5 col-xl-5">
                            <div className="office-information">
                                <h2>Chat with us today!</h2>
                                <div className="single-information">
                                    <div className="bg-shape">
                                        <img src="assets/img/info-shape.png" alt=""/>
                                    </div>
                                    <div className="icon">
                                        <i><img src="assets/img/icons/location.png" alt=""/></i>
                                    </div>
                                    <div className="info-cnt">
                                        <h6>Location</h6>
                                        <p>3459 14th Ave, Menominee, MI 49858</p>
                                    </div>
                                </div>
                                <div className="single-information">
                                    <div className="bg-shape">
                                        <img src="assets/img/info-shape.png" alt=""/>
                                    </div>
                                    <div className="icon">
                                        <i><img src="assets/img/icons/mobile.png" alt=""/></i>
                                    </div>
                                    <div className="info-cnt">
                                        <h6>Phone</h6>
                                        <a href="tel:19068634837">+1-906-863-4837</a>
                                    </div>
                                </div>
                                <div className="single-information">
                                    <div className="bg-shape">
                                        <img src="assets/img/info-shape.png" alt=""/>
                                    </div>
                                    <div className="icon">
                                        <i><img src="assets/img/icons/envelope.png" alt=""/></i>
                                    </div>
                                    <div className="info-cnt">
                                        <h6>Email</h6>
                                        <a href="mailto:kane@riversideccgolf.com">kane@riversideccgolf.com</a>
                                        <a href="mailto:lexi@riversideccgolf.com">lexi@riversideccgolf.com</a>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        <div className="col-md-12 col-xl-12">
                            <div className="contact-form">
                                <h3>Give Us Feedback!</h3>
                                <div style={{display: "flex", justifyContent: "center"}}>
                                    <div className="col-12 col-lg-6" style={{textAlign: "center", marginBottom: "1em"}}>

                                    We are constantly striving to improve our services and provide you with the best experience possible. If we fail to meet those expectations we want to hear about it! Please leave us honest feedback, including contact information so we can reach back out to you if need be
                                    </div>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <input type="text" name="name" required placeholder="Your Full Name" onChange={(e) => setFormData({...formData, name: e.target.value})} />
                                    <input type="text" name="phone" required placeholder="Your Phone" onChange={(e) => setFormData({...formData, phone: e.target.value})} />
                                    
                                    <Box sx={{ width: 200, display: 'flex', alignItems: 'center' }}>
                                        <Rating
                                            name="hover-feedback"
                                            value={rating}
                                            precision={0.5}
                                            getLabelText={getLabelText}
                                            onChange={(event, newValue) => {
                                            setRating(newValue);
                                            setFormData({...formData, rating: newValue})
                                            }}
                                            onChangeActive={(event, newHover) => {
                                            setHover(newHover);
                                            }}
                                            emptyIcon={<Star style={{ opacity: 0.55 }} fontSize="inherit" />}
                                        />
                                        {rating !== null && (
                                            <Box sx={{ ml: 2, whiteSpace: 'nowrap' }}>{labels[hover !== -1 ? hover : rating]}</Box>
                                        )}
                                    </Box>                                    
                                    <textarea name="message" cols="30" rows="10" placeholder="Write Message" onChange={(e) => setFormData({...formData, message: e.target.value})} ></textarea>
                                    <div className="button--wrap">
                                        <button type="submit" className="eg-btn btn--primary golf-btn mx-auto">Submit Now <i className="bi bi-arrow-right"></i></button>
                                    </div>
                                
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Review